import { connect } from 'react-redux';
import { changeClassesEditOrder, changeEditOrder, changeInforEditOrder, checkPostalCodeEditOrder } from './../../../../../actions/editOrder';
import ShipToComponent from './../../../components/ship-to';
import './styles.css';

class ShipTo extends ShipToComponent { }

const mapStateToProps = state => {
    return {
        classes: state.editOrder.classes,
        information: state.editOrder.information,
        order: state.editOrder
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeInformation: payload => {
            dispatch(changeInforEditOrder(payload))
        },
        checkPostalCode: payload => {
            dispatch(checkPostalCodeEditOrder(payload))
        },
        onChange: payload => {
            dispatch(changeEditOrder(payload))
        },
        onChangeClasses: payload => {
            dispatch(changeClassesEditOrder(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShipTo)


// WEBPACK FOOTER //
// ./src/containers/orders/edit/components/ship-to/index.js